import { tw } from '@/utils/tw';
import BaseBreadcrumbsTheme from 'base/components/Breadcrumbs/theme';

export default tw.theme({
  extend: BaseBreadcrumbsTheme,
  slots: {
    base: ['!my-0'],
  },
});
